// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customDisabled[data-v-59a4a95e]{pointer-events:none;opacity:.4}", "",{"version":3,"sources":["webpack://./src/component/cruise/deck/DeckList.vue"],"names":[],"mappings":"AAyFA,iCACE,mBAAA,CACA,UAAA","sourcesContent":[".customDisabled{pointer-events:none;opacity:.4}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
